import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import LoadingModal from 'modals/LoadingModal';

export const RefundPaymentModalContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "RefundPaymentModalContainer" */
      './RefundPaymentModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
